import axios from 'axios';

import { logoutUser } from './store/api/auth';
import { dispatch } from './store';

axios.defaults.baseURL = '/';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post.Accept = 'application/json, text/javascript, */*; q=0.01';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      dispatch(logoutUser());
    }
    return Promise.reject(error);
  },
);
